import { render } from "./ComingSoonComponent.vue?vue&type=template&id=92bd8894&scoped=true"
import script from "./ComingSoonComponent.vue?vue&type=script&lang=js"
export * from "./ComingSoonComponent.vue?vue&type=script&lang=js"

import "./ComingSoonComponent.vue?vue&type=style&index=0&id=92bd8894&scoped=true&lang=css"

import exportComponent from "C:\\Users\\dursu\\Desktop\\projebaum\\güncelbaumind-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92bd8894"]])

export default __exports__